import React, { useState } from 'react';
import DatenschutzModal from './Datenschutz';

const ImpressumModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-brand-dark/95 backdrop-blur-md"
      onClick={onClose}
    >
      <div 
        className="relative w-full max-w-4xl max-h-[90vh] overflow-y-auto bg-white rounded-3xl shadow-2xl animate-scale-in"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 bg-white border-b border-brand-dark/10 px-8 py-6 flex items-center justify-between rounded-t-3xl z-10">
          <h2 className="font-marcellus text-3xl text-brand-dark">Impressum</h2>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-full bg-brand-dark/5 hover:bg-brand-dark/10 flex items-center justify-center transition-colors"
            aria-label="Schließen"
          >
            <svg className="w-6 h-6 text-brand-dark" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="px-8 py-8 font-work text-brand-dark/80 space-y-6">
          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">Angaben gemäß § 5 DDG</h3>
            <p className="leading-relaxed">
              Alexander Suslov<br />
              Im Grünen 17<br />
              24576 Bad Bramstedt<br />
              Deutschland
            </p>
            <p className="mt-4 leading-relaxed">
              <strong>Telefon:</strong> 01747015283<br />
              <strong>E-Mail:</strong> <a href="mailto:info@bodyharmonic.de" className="text-brand-gold hover:underline">info@bodyharmonic.de</a>
            </p>
          </section>

          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">Kleinunternehmer gemäß § 19 UStG</h3>
            <p className="leading-relaxed">
              Es wird keine Umsatzsteuer erhoben und daher auch nicht ausgewiesen.
            </p>
          </section>

          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
            <p className="leading-relaxed">
              Alexander Suslov<br />
              Anschrift wie oben
            </p>
            <p className="mt-4 leading-relaxed">
              <strong>Webdesign & technische Umsetzung:</strong> Dathent Group
            </p>
          </section>

          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">Online-Streitbeilegung</h3>
            <p className="leading-relaxed">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:<br />
              <a 
                href="https://ec.europa.eu/consumers/odr/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-brand-gold hover:underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p className="mt-4 leading-relaxed">
              Ich bin weder verpflichtet noch bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">Haftung für Inhalte</h3>
            <p className="leading-relaxed">
              Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Als Diensteanbieter bin ich nach § 5 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Eine Verpflichtung zur Überwachung übermittelter oder gespeicherter fremder Informationen besteht nicht. Bei Bekanntwerden konkreter Rechtsverletzungen werden entsprechende Inhalte umgehend entfernt.
            </p>
          </section>

          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">Haftung für Links</h3>
            <p className="leading-relaxed">
              Diese Website enthält Verlinkungen zu externen Webseiten Dritter, auf deren Inhalte ich keinen Einfluss habe. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter verantwortlich. Zum Zeitpunkt der Verlinkung waren keine Rechtsverstöße erkennbar. Eine permanente Kontrolle ist ohne konkrete Hinweise nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden entsprechende Links unverzüglich entfernt.
            </p>
          </section>

          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">Urheberrecht</h3>
            <p className="leading-relaxed">
              Alle Inhalte und Werke auf dieser Website unterliegen dem deutschen Urheberrecht. Jegliche Verwertung außerhalb der gesetzlichen Grenzen bedarf der vorherigen schriftlichen Zustimmung des jeweiligen Autors. Downloads und Kopien sind ausschließlich für den privaten, nicht kommerziellen Gebrauch gestattet. Inhalte Dritter werden als solche gekennzeichnet. Bei Bekanntwerden von Rechtsverletzungen werden entsprechende Inhalte umgehend entfernt.
            </p>
          </section>

          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">Bild- und Fotorechte</h3>
            <p className="leading-relaxed">
              Die auf dieser Website verwendeten Bilder und Fotomaterialien stammen entweder aus meinem eigenen Bestand, wurden von mir selbst erstellt oder wurden ordnungsgemäß über eine gültige Lizenz von elements.envato.com bezogen.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [isImpressumOpen, setIsImpressumOpen] = useState(false);
  const [isDatenschutzOpen, setIsDatenschutzOpen] = useState(false);

  return (
    <footer data-testid="footer" className="bg-brand-dark border-t border-white/5 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-32 bg-brand-gold/5 rounded-full blur-3xl" />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 relative z-10">
        <div className="grid md:grid-cols-3 gap-12 items-center">
          {/* Logo & Brand */}
          <div className="text-center md:text-left">
            <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="inline-flex items-center gap-3 group cursor-pointer">
              <img
                src="/logo.png"
                alt="BodyHarmonic Logo"
                className="h-10 w-auto opacity-80 group-hover:opacity-100 transition-all duration-300 group-hover:scale-105"
              />
              <span className="font-marcellus text-xl text-brand-light/80 group-hover:text-brand-gold transition-colors">
                BodyHarmonic
              </span>
            </button>
            <p className="font-work text-sm text-brand-light/40 mt-4 max-w-xs">
              Premium Bodywork & Massage • Hausbesuche
            </p>
          </div>

          {/* Copyright & Social */}
          <div className="text-center">
            <div className="flex justify-center gap-4 mb-4">
              <a
                href="https://www.instagram.com/bodyharmonic"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-brand-light/50 hover:bg-brand-gold hover:border-brand-gold hover:text-brand-dark transition-all duration-300"
                aria-label="Instagram"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a
                href="https://t.me/Doc2005"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-brand-light/50 hover:bg-brand-gold hover:border-brand-gold hover:text-brand-dark transition-all duration-300"
                aria-label="Telegram"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/>
                </svg>
              </a>
            </div>
            <p className="font-work text-sm text-brand-light/40">
              © {currentYear} BodyHarmonic. Alle Rechte vorbehalten.
            </p>
          </div>

          {/* Legal Links */}
          <div className="text-center md:text-right">
            <div className="flex flex-col md:flex-row items-center justify-center md:justify-end gap-4 md:gap-6">
              <button
                onClick={() => setIsDatenschutzOpen(true)}
                data-testid="footer-datenschutz"
                className="font-work text-sm text-brand-light/50 hover:text-brand-gold transition-colors"
              >
                Datenschutz
              </button>
              <button
                onClick={() => setIsImpressumOpen(true)}
                data-testid="footer-impressum"
                className="font-work text-sm text-brand-light/50 hover:text-brand-gold transition-colors"
              >
                Impressum
              </button>
            </div>
            <p className="font-work text-xs text-brand-light/30 mt-4">
              Made with ❤️ in Hamburg
            </p>
            <p className="font-work text-xs text-brand-light/30 mt-2">
              Website by{' '}
              <a
                href="https://dathent.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-brand-gold/60 hover:text-brand-gold transition-colors"
              >
                Dathent Group
              </a>
            </p>
          </div>
        </div>
      </div>

      <ImpressumModal isOpen={isImpressumOpen} onClose={() => setIsImpressumOpen(false)} />
      <DatenschutzModal isOpen={isDatenschutzOpen} onClose={() => setIsDatenschutzOpen(false)} />
    </footer>
  );
};

export default Footer;
